export function RmvDupsParentList(parentList, preProcessorFix) {
  var processedList = [];
  var pL = parentList.length;
  if (parentList.length < 1) return [];

  for (var i = 0; i < pL; i++) {
    var theParent = parentList[i];
    if (preProcessorFix) {
      //The preprocessor has flagged some records as duplicates. We need to un-do that do now.
      var parentPersonID = theParent.GetObjectRecordID();
      var personIDField = theParent.GetRecordIDFieldDef();
      var objMgr = theParent.GetParentClass().GetObjMgr();
      var duplicate = objMgr.FindObjectPartial(personIDField, "DUP " + parentPersonID + "_");
      if (duplicate) {
        duplicate.AdoptChildren(theParent);
        duplicate.SetParent(theParent.GetParent());
        theParent.SetParent(null);
        continue;
      }
    }

    if (theParent["objfilter"] == "exclude") processedList.push(theParent);
  }

  return processedList;
}
